export default "__VITE_ASSET__tcnj7LPs__"